// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.plant-diagnosis-container {
  font-family: Arial, sans-serif;
  padding: 20px;
}
.plant-diagnosis-container .training-content {
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 10px;
  background: #c3eee0;
}
.plant-diagnosis-container .training-content .images-preview {
  display: flex;
  overflow-x: auto;
  /* Cho phép cuộn ngang */
  gap: 16px;
  /* Khoảng cách giữa các ảnh */
  padding: 8px;
  scroll-snap-type: x mandatory;
  /* Kích hoạt snap scroll */
}
.plant-diagnosis-container .training-content .image-preview-item {
  flex: 0 0 calc(50% - 16px);
  /* Mỗi ảnh chiếm 50% chiều rộng (2 ảnh trên 1 hàng) */
  scroll-snap-align: start;
  /* Căn ảnh khi cuộn */
  position: relative;
}
.plant-diagnosis-container .training-content .image-diagnostis {
  width: 100%;
  height: 500px;
  border-radius: 8px;
}
.plant-diagnosis-container .training-content .delete-image {
  position: absolute;
  top: 8px;
  right: 8px;
  background: rgba(0, 0, 0, 0.5);
  border: none;
  border-radius: 50%;
  padding: 4px;
  cursor: pointer;
}
.plant-diagnosis-container .image-upload-section {
  text-align: center;
}
.plant-diagnosis-container .image-upload-section .image-upload-placeholder {
  width: 200px;
  height: 200px;
  margin: 0 auto 10px;
  border: 2px dashed #ccc;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  overflow: hidden;
}
.plant-diagnosis-container .image-upload-section .image-upload-placeholder .image-icon {
  font-size: 48px;
  color: #888;
}
.plant-diagnosis-container .image-upload-section .uploaded-image {
  max-width: 100%;
  max-height: 100%;
}
.plant-diagnosis-container .upload-button {
  padding: 10px 20px;
  font-size: 16px;
  background-color: #0020c2;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 10px;
}
.plant-diagnosis-container .upload-button:hover {
  background: #030458;
}
.plant-diagnosis-container .upload-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
.plant-diagnosis-container .diagnose-button {
  padding: 10px 20px;
  font-size: 16px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
.plant-diagnosis-container .diagnose-button:hover {
  background: #005f2c;
}
.plant-diagnosis-container .diagnose-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
.plant-diagnosis-container .note {
  margin-top: 20px;
  background: #ffe7e7;
  padding: 10px;
  border-radius: 4px;
  color: #d9534f;
}
.plant-diagnosis-container .note h4 {
  margin-top: 0;
}
.plant-diagnosis-container .box-category {
  border: solid 2px #005f2c;
}
.plant-diagnosis-container .max-video-camera {
  max-width: -webkit-fill-available;
}
.plant-diagnosis-container .image-preview-item {
  position: relative;
}
.plant-diagnosis-container .image-preview-item .delete-image {
  position: absolute;
  top: 0;
  right: 0;
  width: 30px;
  height: 30px;
  border: none;
}
.plant-diagnosis-container .crop-slider .crop-item {
  text-align: center;
  width: auto !important;
  opacity: 0.7;
  transition: all 0.3s ease;
}
.plant-diagnosis-container .crop-slider .crop-item.active {
  opacity: 1;
}
.plant-diagnosis-container .crop-slider .crop-item.active .tab-button {
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.2);
  opacity: 1;
}
.plant-diagnosis-container .crop-slider .crop-item.active .crop-name {
  opacity: 1;
  color: #005f2c;
}
.plant-diagnosis-container .crop-slider .crop-item:hover {
  opacity: 1;
}
.plant-diagnosis-container .crop-slider .crop-item:hover .crop-name {
  color: #005f2c;
}
.plant-diagnosis-container .crop-slider .crop-item .tab-button {
  width: 80px;
  height: 80px;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  opacity: 0.7;
}
.plant-diagnosis-container .crop-slider .crop-item .tab-button:hover {
  opacity: 1;
}
.plant-diagnosis-container .crop-slider .crop-item .crop-name {
  margin-top: 8px;
  font-size: 14px;
  font-weight: bold;
  color: #333;
  opacity: 0.7;
}
.plant-diagnosis-container .crop-slider .crop-item .crop-name:hover {
  opacity: 1;
}
.plant-diagnosis-container .crop-slider .slider-next-arrow,
.plant-diagnosis-container .crop-slider .slider-prev-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
  cursor: pointer;
}
.plant-diagnosis-container .crop-slider .slider-next-arrow {
  right: -30px;
}
.plant-diagnosis-container .crop-slider .slider-prev-arrow {
  left: -30px;
}
.plant-diagnosis-container .crop-slider .slick-prev:before {
  color: #005f2c;
}
.plant-diagnosis-container .crop-slider .slick-next:before {
  color: #005f2c;
}
.plant-diagnosis-container .camera-app {
  display: flex;
  justify-content: center;
}
.plant-diagnosis-container .camera-app .webcam-container {
  position: relative;
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  border-radius: 16px;
  overflow: hidden;
}
.plant-diagnosis-container .camera-app .webcam-container .toggle-camera-icon {
  position: absolute;
  top: 10px;
  right: 10px;
  background: rgba(0, 0, 0, 0.2);
  color: white;
  border: none;
  border-radius: 50%;
  padding: 8px;
  cursor: pointer;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
}
.plant-diagnosis-container .camera-app .webcam-container .toggle-camera-icon:hover {
  background: rgba(0, 0, 0, 0.5);
}
.plant-diagnosis-container .camera-app .webcam-container .webcam-view {
  width: 100%;
  border-radius: 8px;
}
.plant-diagnosis-container .camera-app .webcam-container .capture-button {
  position: absolute;
  bottom: 10px;
  width: 50px;
  height: 50px;
  background: rgba(0, 0, 0, 0.2);
  border: none;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.plant-diagnosis-container .camera-app .webcam-container .capture-button .inner-circle {
  min-width: 30px;
  min-height: 30px;
  background: red;
  border-radius: 50%;
}
.plant-diagnosis-container .camera-app .webcam-container .power-button {
  position: absolute;
  bottom: 10px;
  right: 10px;
  background: rgba(0, 0, 0, 0.2);
  color: white;
  border: none;
  border-radius: 50%;
  padding: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}
.plant-diagnosis-container .camera-app .webcam-container .power-button:hover {
  background: rgba(0, 0, 0, 0.5);
}
.plant-diagnosis-container .camera-app .start-camera-button {
  background: #007bff;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 10px 20px;
  cursor: pointer;
}
.plant-diagnosis-container .camera-app .start-camera-button:hover {
  background: #0056b3;
}`, "",{"version":3,"sources":["webpack://./src/pages/TrainingData/Components/PlantDiagnosis.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,8BAAA;EACA,aAAA;AAEF;AAAE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;AAEJ;AAAI;EACE,aAAA;EACA,gBAAA;EACA,wBAAA;EACA,SAAA;EACA,6BAAA;EACA,YAAA;EACA,6BAAA;EACA,0BAAA;AAEN;AACI;EACE,0BAAA;EACA,qDAAA;EACA,wBAAA;EACA,qBAAA;EACA,kBAAA;AACN;AAEI;EACE,WAAA;EACA,aAAA;EACA,kBAAA;AAAN;AAGI;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,8BAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AADN;AAKE;EACE,kBAAA;AAHJ;AAKI;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAHN;AAKM;EACE,eAAA;EACA,WAAA;AAHR;AAOI;EACE,eAAA;EACA,gBAAA;AALN;AASE;EACE,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AAPJ;AASI;EACE,mBAAA;AAPN;AAUI;EACE,sBAAA;EACA,mBAAA;AARN;AAYE;EACE,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AAVJ;AAYI;EACE,mBAAA;AAVN;AAaI;EACE,sBAAA;EACA,mBAAA;AAXN;AAeE;EACE,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;AAbJ;AAeI;EACE,aAAA;AAbN;AAiBE;EACE,yBAAA;AAfJ;AAkBE;EACE,iCAAA;AAhBJ;AAmBE;EACE,kBAAA;AAjBJ;AAmBI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAjBN;AAsBI;EACE,kBAAA;EACA,sBAAA;EACA,YAAA;EACA,yBAAA;AApBN;AAsBM;EACE,UAAA;AApBR;AAsBQ;EACE,yCAAA;EACA,UAAA;AApBV;AAuBQ;EACE,UAAA;EACA,cAAA;AArBV;AAyBM;EACE,UAAA;AAvBR;AAyBQ;EACE,cAAA;AAvBV;AA2BM;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;AAzBR;AA2BQ;EACE,UAAA;AAzBV;AA6BM;EACE,eAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;AA3BR;AA6BQ;EACE,UAAA;AA3BV;AAgCI;;EAEE,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;EACA,eAAA;AA9BN;AAiCI;EACE,YAAA;AA/BN;AAkCI;EACE,WAAA;AAhCN;AAmCI;EACE,cAAA;AAjCN;AAoCI;EACE,cAAA;AAlCN;AAsCE;EACE,aAAA;EACA,uBAAA;AApCJ;AAsCI;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;AApCN;AAsCM;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,8BAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AApCR;AAuCM;EACE,8BAAA;AArCR;AAwCM;EACE,WAAA;EACA,kBAAA;AAtCR;AAyCM;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAvCR;AA0CM;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AAxCR;AA2CM;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,8BAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAzCR;AA4CM;EACE,8BAAA;AA1CR;AA8CI;EACE,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AA5CN;AA+CI;EACE,mBAAA;AA7CN","sourcesContent":[".plant-diagnosis-container {\n  font-family: Arial, sans-serif;\n  padding: 20px;\n\n  .training-content {\n    padding: 20px;\n    border: 1px solid #ccc;\n    border-radius: 10px;\n    background: #c3eee0;\n\n    .images-preview {\n      display: flex;\n      overflow-x: auto;\n      /* Cho phép cuộn ngang */\n      gap: 16px;\n      /* Khoảng cách giữa các ảnh */\n      padding: 8px;\n      scroll-snap-type: x mandatory;\n      /* Kích hoạt snap scroll */\n    }\n\n    .image-preview-item {\n      flex: 0 0 calc(50% - 16px);\n      /* Mỗi ảnh chiếm 50% chiều rộng (2 ảnh trên 1 hàng) */\n      scroll-snap-align: start;\n      /* Căn ảnh khi cuộn */\n      position: relative;\n    }\n\n    .image-diagnostis {\n      width: 100%;\n      height: 500px;\n      border-radius: 8px;\n    }\n\n    .delete-image {\n      position: absolute;\n      top: 8px;\n      right: 8px;\n      background: rgba(0, 0, 0, 0.5);\n      border: none;\n      border-radius: 50%;\n      padding: 4px;\n      cursor: pointer;\n    }\n  }\n\n  .image-upload-section {\n    text-align: center;\n\n    .image-upload-placeholder {\n      width: 200px;\n      height: 200px;\n      margin: 0 auto 10px;\n      border: 2px dashed #ccc;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      border-radius: 10px;\n      overflow: hidden;\n\n      .image-icon {\n        font-size: 48px;\n        color: #888;\n      }\n    }\n\n    .uploaded-image {\n      max-width: 100%;\n      max-height: 100%;\n    }\n  }\n\n  .upload-button {\n    padding: 10px 20px;\n    font-size: 16px;\n    background-color: #0020c2;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    margin-top: 10px;\n\n    &:hover {\n      background: #030458;\n    }\n\n    &:disabled {\n      background-color: #ccc;\n      cursor: not-allowed;\n    }\n  }\n\n  .diagnose-button {\n    padding: 10px 20px;\n    font-size: 16px;\n    background-color: #4caf50;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n\n    &:hover {\n      background: #005f2c;\n    }\n\n    &:disabled {\n      background-color: #ccc;\n      cursor: not-allowed;\n    }\n  }\n\n  .note {\n    margin-top: 20px;\n    background: #ffe7e7;\n    padding: 10px;\n    border-radius: 4px;\n    color: #d9534f;\n\n    h4 {\n      margin-top: 0;\n    }\n  }\n\n  .box-category {\n    border: solid 2px #005f2c;\n  }\n\n  .max-video-camera {\n    max-width: -webkit-fill-available;\n  }\n\n  .image-preview-item {\n    position: relative;\n\n    .delete-image {\n      position: absolute;\n      top: 0;\n      right: 0;\n      width: 30px;\n      height: 30px;\n      border: none;\n    }\n  }\n\n  .crop-slider {\n    .crop-item {\n      text-align: center;\n      width: auto !important;\n      opacity: 0.7;\n      transition: all 0.3s ease;\n\n      &.active {\n        opacity: 1;\n\n        .tab-button {\n          box-shadow: 0 6px 10px rgba(0, 0, 0, 0.2);\n          opacity: 1;\n        }\n\n        .crop-name {\n          opacity: 1;\n          color: #005f2c;\n        }\n      }\n\n      &:hover {\n        opacity: 1;\n\n        .crop-name {\n          color: #005f2c;\n        }\n      }\n\n      .tab-button {\n        width: 80px;\n        height: 80px;\n        border: none;\n        border-radius: 10px;\n        cursor: pointer;\n        opacity: 0.7;\n\n        &:hover {\n          opacity: 1;\n        }\n      }\n\n      .crop-name {\n        margin-top: 8px;\n        font-size: 14px;\n        font-weight: bold;\n        color: #333;\n        opacity: 0.7;\n\n        &:hover {\n          opacity: 1;\n        }\n      }\n    }\n\n    .slider-next-arrow,\n    .slider-prev-arrow {\n      position: absolute;\n      top: 50%;\n      transform: translateY(-50%);\n      z-index: 1;\n      cursor: pointer;\n    }\n\n    .slider-next-arrow {\n      right: -30px;\n    }\n\n    .slider-prev-arrow {\n      left: -30px;\n    }\n\n    .slick-prev:before {\n      color: #005f2c;\n    }\n\n    .slick-next:before {\n      color: #005f2c;\n    }\n  }\n\n  .camera-app {\n    display: flex;\n    justify-content: center;\n\n    .webcam-container {\n      position: relative;\n      width: 100%;\n      max-width: 400px;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: flex-end;\n      border-radius: 16px;\n      overflow: hidden;\n\n      .toggle-camera-icon {\n        position: absolute;\n        top: 10px;\n        right: 10px;\n        background: rgba(0, 0, 0, 0.2);\n        color: white;\n        border: none;\n        border-radius: 50%;\n        padding: 8px;\n        cursor: pointer;\n        z-index: 10;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      }\n\n      .toggle-camera-icon:hover {\n        background: rgba(0, 0, 0, 0.5);\n      }\n\n      .webcam-view {\n        width: 100%;\n        border-radius: 8px;\n      }\n\n      .capture-button {\n        position: absolute;\n        bottom: 10px;\n        width: 50px;\n        height: 50px;\n        background: rgba(0, 0, 0, 0.2);\n        border: none;\n        border-radius: 50%;\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      }\n\n      .capture-button .inner-circle {\n        min-width: 30px;\n        min-height: 30px;\n        background: red;\n        border-radius: 50%;\n      }\n\n      .power-button {\n        position: absolute;\n        bottom: 10px;\n        right: 10px;\n        background: rgba(0, 0, 0, 0.2);\n        color: white;\n        border: none;\n        border-radius: 50%;\n        padding: 10px;\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        z-index: 10;\n      }\n\n      .power-button:hover {\n        background: rgba(0, 0, 0, 0.5);\n      }\n    }\n\n    .start-camera-button {\n      background: #007bff;\n      color: white;\n      border: none;\n      border-radius: 8px;\n      padding: 10px 20px;\n      cursor: pointer;\n    }\n\n    .start-camera-button:hover {\n      background: #0056b3;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
